import React, { Component } from "react";
import {
  img_url11,
  img_url12,
  img_url13,
  img_url14,
} from "../Constant/Constants";
import "../Landingpage/Landing.css";
import { Link } from "react-router-dom";

export class Blogs extends Component {
  render() {
    return (
      <>
        <h1 className="blog_text">Read about Indian Mythological characters</h1>
        <div className="blog_main_div">
          <div className="blog_img_div">
            <div className="blog_single_img">
              <img className="blog_img" src={img_url11}></img>
              <h2 class="blog_god_name">Lord Shiva</h2>
              <p className="blog_god_details">
                The Sanatan Dharma that is far from the confinement of time also
                boasts of timeless cosmic characters who spent a predetermined
                time on the face...
              </p>
            </div>
            <div className="blog_single_img">
              <img className="blog_img" src={img_url12}></img>
              <h2 class="blog_god_name">Lord Brahma</h2>
              <p className="blog_god_details">
                The Rig-Veda explains the concept of Brahma as a word that was
                used for deciphering a sacred mysterious power that helped
                create the world. In one...
              </p>
            </div>
            <div className="blog_single_img">
              <img className="blog_img" src={img_url13}></img>
              <h2 class="blog_god_name">Lord Vishnu</h2>
              <p className="blog_god_details">
                Lord Vishnu, in Hindu Mythology, is reckoned to have been vested
                with the quality of permanence, continuity, and preservation. In
                the Rig Veda, Vishnu,...
              </p>
            </div>
            <div className="blog_single_img">
              <img className="blog_img" src={img_url14}></img>
              <h2 class="blog_god_name">Goddess Lakshmi</h2>
              <p className="blog_god_details">
                A symbol of beauty, fertility, and auspiciousness, Goddess
                Lakshmi remain an important Hindu mythological character.
                Reckoned to be the provider of...
              </p>
            </div>
            {/* <div className="blog_single_img">
              <img className="blog_img" src=""></img>
            </div>
            <div className="blog_single_img">
              <img className="blog_img" src=""></img>
            </div>
            <div className="blog_single_img">
              <img className="blog_img" src=""></img>
            </div>
            <div className="blog_single_img">
              <img className="blog_img" src=""></img>
            </div> */}
          </div>
        </div>
        <Link to="/blogs">
          <button className="view_temple" style = {{marginTop:"70px",marginBottom:"5%"}}>Browse all</button>
        </Link>
      </>
    );
  }
}

export default Blogs;
